export default __webpack_public_path__ + "static/doomcatrescue-6dc01b12b776091f29316dab3f593870.jpg";